import { render } from "./KoruAddressMap.vue?vue&type=template&id=a4cd26ca&ts=true"
import script from "./KoruAddressMap.vue?vue&type=script&lang=ts"
export * from "./KoruAddressMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__